import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import IngredientHandler from '../recipes/IngredientHandler';
import { preferenceUpdateCerealMixService } from '../../services/preferenceUpdateCerealMixService';
import PreferenceStructureValue from './PreferenceStructureValue';
import {PreferenceType} from "../../services/preferenceTypes";
import {preferenceSaveService} from "../../services/preferenceSaveService";
import { Select } from '@chapche/ui';

const checkNeedToAddValueField = (parentMode, index) => {
    if (parentMode) {
        if (preferenceSaveService.getPreference().preferenceType === PreferenceType.PROPERTY ||
            preferenceSaveService.getPreference().preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY ||
            preferenceSaveService.getPreference().preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL ||
            preferenceSaveService.getPreference().preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_DAY ||
            preferenceSaveService.getPreference().preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_MEAL ||
            preferenceSaveService.getPreference().preferenceType === PreferenceType.RECIPE_CHARACTERISTIC) {
            return preferenceSaveService.getPreference().preferenceItemCodes &&
                preferenceSaveService.getPreference().preferenceItemCodes.length > 0;
        }
        return false;
    } else {
        if (index === undefined) {
            return false;
        } else {
            if (preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.PROPERTY ||
                preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.MACRONUTRIENT_PER_DAY ||
                preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.MACRONUTRIENT_PER_MEAL ||
                preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_DAY ||
                preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.PRODUCT_CATEGORY_PER_MEAL ||
                preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.RECIPE_CHARACTERISTIC) {
                return preferenceSaveService.getPreference().combinedPreferences[index].preferenceItemCodes &&
                    preferenceSaveService.getPreference().combinedPreferences[index].preferenceItemCodes.length > 0;
            }
            return false;
        }
    }
};

const PreferenceStructureItemCode = ({ preferenceStructureItem, index, parentMode = true }) => {
    const { i18n } = useTranslation();
    const [itemCode, setItemCode] = useState<string>("");
    const [currentPreferenceItem, setCurrentPreferenceItem] = useState<object>(null);

    useEffect(() => {
        setItemCode(preferenceStructureItem.itemCode);
        setCurrentPreferenceItem(preferenceStructureItem);
    }, [preferenceStructureItem]);

    const handleUpdatePreferenceItem = (field: string, value) => {
        const copy = {...currentPreferenceItem};
        copy[field] = value;
        setCurrentPreferenceItem(copy);
        if (parentMode) {
            preferenceSaveService.updatePreferenceItem(field, value);
        } else {
            preferenceSaveService.updateCombinedPreferenceItem(index, field, value);
        }
    };

    const handleUpdateItemCode = (value) => {
        setItemCode(value);
        handleUpdatePreferenceItem('itemCode', value);
    };

    const isCerealMix = () => {
        if (parentMode) {
            return preferenceSaveService.getPreference().preferenceType === PreferenceType.CEREAL_MIX;
        } else {
            if (index === undefined) {
                return false;
            } else {
                return preferenceSaveService.getPreference().combinedPreferences[index].preferenceType === PreferenceType.CEREAL_MIX;
            }
        }
    };

    return (
        <label className="block__text preference__form-label">
            <span>{i18n.t('app.page.preference.addTitles.preferenceItemCode')}</span>
            {isCerealMix() ?
                <IngredientHandler selectWithTokensManager={preferenceUpdateCerealMixService} />
                :
                <Select
                    fullWidth
                    className="mt-0"
                    value={itemCode}
                    options={preferenceSaveService.getPossibleCodeValues(parentMode, index).map((it) => ({
                        value: it.id,
                        label: it.name,
                    }))}
                    onChange={handleUpdateItemCode}
                /> }
            {checkNeedToAddValueField(parentMode, index) ?
                <PreferenceStructureValue
                    parentMode={parentMode}
                    index={index}
                    preferenceStructureItem={currentPreferenceItem}
                    handleUpdatePreferenceItem={handleUpdatePreferenceItem}/>
                :
                null
            }
        </label> 
    );
};

export default PreferenceStructureItemCode;
